import { REPAYMENT_TYPES } from 'loans.module/common/domain/constants.loans';
import { STATES } from 'common/domain/states';
import { LOANS } from '../../../common/domain/constants.loans';

class LoansRepaymentFormController {

  constructor(EventEmitter, $scope, $state) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.scope = $scope;
    this.state = $state;

    this.movementDate = new Date();
    this.errors = {};
    this.valid = false;

    this.repaymentAmount = 0;
    this.previousAmount = 0;
    this.convertedAmount = 0;

  }

  $onInit() {
    this.watchRepaymentType();

    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  watchRepaymentType() {
    this.scope.$watch(() => this.repaymentType, newValue => {
      const isTotalRepayment = newValue && newValue === REPAYMENT_TYPES.TOTAL;
      this.setFormData(isTotalRepayment);
      this.setFormValidity();
      this.isTotalRepayment = newValue && newValue === REPAYMENT_TYPES.TOTAL;
    });
  }

  setFormData(isTotalRepayment) {
    this.blocked = isTotalRepayment;

    if (isTotalRepayment) {
      this.previousAmount = this.repaymentAmount;
      this.repaymentAmount = String(angular.copy(this.loan.amountPending)).replace(/\./g, ',');
    } else {
      this.repaymentAmount = String(this.previousAmount).replace(/\./g, ',');
    }
  }

  setFormValidity() {
    this.convertedAmount = this.convertAmount(this.repaymentAmount);
    this.errors.ltZero = this.convertedAmount < 0;
    this.errors.zero = this.convertedAmount === 0;

    this.errors.gtAmount = this.convertedAmount > this.loan.amountPending;

    this.valid = !this.errors.ltZero && !this.errors.zero && !this.errors.gtAmount;

    if (this.floatingActionButtons) {
      this.floatingActionButtons[0].disabled = !this.valid;
    }
  }

  convertAmount(amount){
    if(typeof amount === 'string')
      return parseFloat(parseFloat(amount.replace(/\,/g, '.')).toFixed(2));
    else 
      return parseFloat(amount.toFixed(2));
  }
  
  submit() {
    this.convertedAmount = this.convertAmount(this.repaymentAmount);
    this.onCreateRepayment(this.EventEmitter({
      loan: this.loan,
      repaymentAmount: this.convertedAmount
    }));
  }

  cancel() {
    this.state.go(STATES.LOANS.MY_LOANS);
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.CONFIRM',
        simulate: 'GLOBALS.BUTTON_ACTION.SIMULATE',
        disabled: true
      }, {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

  isVivienda(){
    return this.loan.modalityCode === LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loan.modalityCode === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN;
  }
}

export default LoansRepaymentFormController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentForm/loansRepaymentForm.controller.js